module.exports = __webpack_public_path__ + "7f6d69079f9c145e76b493bd05b9e85b.MP3";